export default __webpack_public_path__ + "static/media/blogs-banner.b3edddf6.jpg";